import type { ManualActionResponse } from "@ando/core";
import type { ActionFieldValue } from "@ando/ui";

/**
 * Map a manual-action / ai-fill response's unified payload schema into the
 * ``{ field_name: value }`` map the action store + ``<ActionFieldEditor>``
 * consume. Shared by ``useCreateManualAction`` (seed an empty proposal) and
 * ``ActionAiFillBar`` (re-seed after "Compila con AI") — single source so the
 * value coercion stays identical on both paths.
 */
export function proposedFieldsFromManualResponse(
  res: ManualActionResponse,
): Record<string, ActionFieldValue> {
  const out: Record<string, ActionFieldValue> = {};
  for (const f of res.payload_schema.fields) {
    out[f.name] = (f.value ?? null) as ActionFieldValue;
  }
  return out;
}
